// Mock data for LEP - Logística Ejecutiva Premium (Perú)

export const routes = [
  { id: "r1", origin: "Aeropuerto Jorge Chávez", destination: "Miraflores", duration: "45 min", distance: "18 km", price: 89 },
  { id: "r2", origin: "Aeropuerto Jorge Chávez", destination: "San Isidro", duration: "40 min", distance: "16 km", price: 85 },
  { id: "r3", origin: "Aeropuerto Jorge Chávez", destination: "Barranco", duration: "55 min", distance: "22 km", price: 99 },
  { id: "r4", origin: "Aeropuerto Jorge Chávez", destination: "Surco", duration: "50 min", distance: "24 km", price: 105 },
  { id: "r5", origin: "Miraflores", destination: "Aeropuerto Jorge Chávez", duration: "45 min", distance: "18 km", price: 89 },
  { id: "r6", origin: "San Isidro", destination: "Aeropuerto Jorge Chávez", duration: "40 min", distance: "16 km", price: 85 },
  { id: "r7", origin: "Aeropuerto Jorge Chávez", destination: "La Molina", duration: "1 h 5 min", distance: "31 km", price: 125 },
  { id: "r8", origin: "Aeropuerto Jorge Chávez", destination: "San Borja", duration: "48 min", distance: "20 km", price: 95 },
];

export const services = [
  { id: "s1", title: "Traslados Ejecutivos", desc: "Sedanes premium con conductor uniformado para reuniones y eventos.", icon: "briefcase" },
  { id: "s2", title: "Traslados Aeropuerto", desc: "Recojo puntual con monitoreo de vuelos y espera sin cargo.", icon: "plane" },
  { id: "s3", title: "Viajes Corporativos", desc: "Cuentas empresariales con facturación mensual y reportes.", icon: "building" },
  { id: "s4", title: "Turismo Premium", desc: "Tours privados por Lima y valle sagrado con guía discreto.", icon: "map" },
];

export const howItWorks = [
  { step: "01", title: "Reserva tu traslado", desc: "Elige origen, destino y horario. Recibe cotización al instante." },
  { step: "02", title: "Confirma y paga", desc: "Yape, transferencia o efectivo al conductor. Sin sorpresas." },
  { step: "03", title: "Disfruta el viaje", desc: "Conductor uniformado, sedán negro impecable, puntualidad garantizada." },
];

export const stats = [
  { value: "+10,000", label: "Viajes ejecutivos" },
  { value: "100%", label: "Conductores verificados" },
  { value: "24/7", label: "Cobertura horaria" },
  { value: "4.9★", label: "Calificación promedio" },
];

export const testimonials = [
  { name: "Alejandra Villarán", role: "CEO · Grupo Andina", quote: "Puntualidad impecable. Es mi opción de confianza para clientes internacionales que llegan al Jorge Chávez." },
  { name: "Carlos Menéndez", role: "Director Comercial · BCP", quote: "Conductores discretos, autos siempre en estado óptimo. La app es simple y elegante." },
  { name: "Rocío Palma", role: "Abogada Corporativa", quote: "Reservo con 20 minutos de anticipación y siempre está listo. Cero fricción, cero estrés." },
];

export const reservations = [
  { id: "LEP-2401", client: "Alejandra Villarán", route: "Aeropuerto → Miraflores", date: "15 Dic 2025", time: "18:30", flight: "LA2405", driver: "Miguel Ramos", vehicle: "Mercedes E-Class · A1F-274", status: "Confirmado", price: 89, payment: "Yape" },
  { id: "LEP-2402", client: "Carlos Menéndez", route: "San Isidro → Aeropuerto", date: "16 Dic 2025", time: "05:15", flight: "AV0091", driver: "Julio Cárdenas", vehicle: "BMW Serie 5 · B2K-108", status: "Pendiente", price: 85, payment: "Transferencia" },
  { id: "LEP-2403", client: "Rocío Palma", route: "Aeropuerto → Barranco", date: "12 Dic 2025", time: "22:40", flight: "LA0570", driver: "Enrique Solís", vehicle: "Mercedes E-Class · C3M-501", status: "Completado", price: 99, payment: "Efectivo" },
  { id: "LEP-2404", client: "Diego Ferrari", route: "Aeropuerto → Surco", date: "14 Dic 2025", time: "12:10", flight: "LA2101", driver: "Miguel Ramos", vehicle: "Mercedes E-Class · A1F-274", status: "Cancelado", price: 105, payment: "Yape" },
  { id: "LEP-2405", client: "Sofía Delgado", route: "Aeropuerto → La Molina", date: "17 Dic 2025", time: "09:00", flight: "H20081", driver: "Ricardo Peña", vehicle: "Audi A6 · D4N-880", status: "Confirmado", price: 125, payment: "Yape" },
];

export const drivers = [
  { id: "d1", name: "Miguel Ramos", phone: "+51 987 123 456", license: "Q-38472910", rating: 4.98, trips: 1240, vehicle: "Mercedes E-Class Negro · A1F-274", status: "Activo" },
  { id: "d2", name: "Julio Cárdenas", phone: "+51 998 445 220", license: "Q-11029833", rating: 4.95, trips: 980, vehicle: "BMW Serie 5 Negro · B2K-108", status: "En viaje" },
  { id: "d3", name: "Enrique Solís", phone: "+51 954 220 118", license: "Q-77821049", rating: 4.92, trips: 810, vehicle: "Mercedes E-Class Negro · C3M-501", status: "Activo" },
  { id: "d4", name: "Ricardo Peña", phone: "+51 933 100 809", license: "Q-40188271", rating: 4.89, trips: 620, vehicle: "Audi A6 Negro · D4N-880", status: "Descanso" },
];

export const customers = [
  { id: "u1", name: "Alejandra Villarán", email: "a.villaran@grupoandina.pe", phone: "+51 999 001 220", trips: 42, spent: 3980, tier: "Diamante" },
  { id: "u2", name: "Carlos Menéndez", email: "c.menendez@bcp.pe", phone: "+51 987 220 118", trips: 28, spent: 2680, tier: "Oro" },
  { id: "u3", name: "Rocío Palma", email: "r.palma@estudio-palma.pe", phone: "+51 954 780 100", trips: 15, spent: 1490, tier: "Plata" },
  { id: "u4", name: "Diego Ferrari", email: "d.ferrari@ferrari-consult.pe", phone: "+51 933 400 811", trips: 9, spent: 950, tier: "Plata" },
  { id: "u5", name: "Sofía Delgado", email: "s.delgado@estudiodelgado.pe", phone: "+51 999 552 003", trips: 5, spent: 620, tier: "Nuevo" },
];

export const kpis = {
  tripsToday: 34,
  revenueToday: 3480,
  activeDrivers: 12,
  pending: 7,
  weekTrend: [
    { day: "Lun", trips: 28, revenue: 2540 },
    { day: "Mar", trips: 31, revenue: 2890 },
    { day: "Mié", trips: 35, revenue: 3320 },
    { day: "Jue", trips: 29, revenue: 2740 },
    { day: "Vie", trips: 42, revenue: 4120 },
    { day: "Sáb", trips: 38, revenue: 3810 },
    { day: "Dom", trips: 34, revenue: 3480 },
  ],
  routeMix: [
    { name: "Miraflores", value: 34 },
    { name: "San Isidro", value: 28 },
    { name: "Barranco", value: 14 },
    { name: "Surco", value: 12 },
    { name: "Otros", value: 12 },
  ],
};

// Driver optimized route (mock coordinates on a 800x500 canvas)
export const optimizedRoute = {
  totalDistance: "38 km",
  totalTime: "1 h 24 min",
  startedAt: "18:15",
  stops: [
    { n: 1, client: "Alejandra Villarán", address: "Av. Larco 1250, Miraflores", eta: "18:52", leg: "18 km · 42 min", phone: "+51 999 001 220", flight: "LA2405 · Terminal Nac." },
    { n: 2, client: "Carlos Menéndez", address: "Calle Los Naranjos 380, San Isidro", eta: "19:14", leg: "4.2 km · 12 min", phone: "+51 987 220 118", flight: "AV0091 · Terminal Int." },
    { n: 3, client: "Rocío Palma", address: "Jr. Colina 210, Barranco", eta: "19:34", leg: "5.8 km · 15 min", phone: "+51 954 780 100", flight: "LA0570 · Terminal Nac." },
    { n: 4, client: "Sofía Delgado", address: "Av. La Molina 2200, La Molina", eta: "20:03", leg: "12 km · 22 min", phone: "+51 999 552 003", flight: "H20081 · Terminal Nac." },
  ],
  // SVG polyline points connecting stops (canvas 800x500)
  path: "60,420 210,340 380,300 520,180 720,120",
  pins: [
    { x: 60, y: 420, label: "★" }, // start
    { x: 210, y: 340, label: "1" },
    { x: 380, y: 300, label: "2" },
    { x: 520, y: 180, label: "3" },
    { x: 720, y: 120, label: "4" },
  ],
};

export const clientProfile = {
  name: "Alejandra Villarán",
  email: "a.villaran@grupoandina.pe",
  phone: "+51 999 001 220",
  tier: "Diamante",
  memberSince: "Mar 2023",
  trips: 42,
  savedAddresses: [
    { label: "Casa", address: "Av. El Golf 250, San Isidro" },
    { label: "Oficina", address: "Torre Real 3, Piso 18, San Isidro" },
    { label: "Aeropuerto", address: "Aeropuerto Internacional Jorge Chávez" },
  ],
};

export const nextTrip = {
  id: "LEP-2401",
  route: "Aeropuerto Jorge Chávez → Av. Larco 1250, Miraflores",
  date: "15 Dic 2025",
  time: "18:30",
  flight: "LATAM LA2405 · Terminal Nacional",
  driver: "Miguel Ramos",
  vehicle: "Mercedes E-Class Negro · A1F-274",
  status: "Confirmado",
  price: 89,
};

// Map mock — city grid points for destination selection
export const cityBlocks = Array.from({ length: 42 }, (_, i) => ({
  id: i,
  x: (i * 73) % 780,
  y: ((i * 137) % 460) + 20,
  w: 60 + ((i * 17) % 90),
  h: 40 + ((i * 23) % 60),
}));

